import React from "react";
import { Divider } from "antd";
import InfoSlider from "./InfoSlider";
import {
  InvoiceIcon,
  MessageIcon,
  PendingOrder,
  VolumeUpIcon,
} from "../../../common/utils/Icons";

const DashboardHeader = ({ orderMetrics }) => {
  const stats = [
    {
      title: "Sales Balance",
      value: orderMetrics?.financial?.totalSalesBalance ?? 0,
      icon: PendingOrder,
      color: "color_5",
      isCurrency: true,
    },
    {
      title: "Today",
      value: orderMetrics?.orders?.todayOrders ?? 0,
      icon: InvoiceIcon,
      color: "color_2",
    },
    {
      title: "Today",
      value: orderMetrics?.financial?.todaySalesBalance ?? 0,
      icon: VolumeUpIcon,
      color: "color_3",
      isCurrency: true,
    },
    {
      title: "Sales till date",
      value: orderMetrics?.financial?.salesTillDate ?? 0,
      icon: MessageIcon,
      color: "color_1",
      isCurrency: true,
    },
  ];

  return (
    <>
      <div className="pt-10">
        <h5 className="text-4xl text-gray-900">My Business Dashboard</h5>
        <Divider style={{ margin: "0px 0 5px" }} />
      </div>
      <InfoSlider stats={stats} />
    </>
  );
};

export default DashboardHeader;
